import React from 'react';

const steps = [
  {
    num: '01',
    title: 'Submit a Request',
    desc: 'End users log in to the self-service portal and submit a ticket — incident, service request, or enhancement — in seconds. Smart forms auto-classify and prioritise.',
  },
  {
    num: '02',
    title: 'Auto-Route & Assign',
    desc: 'ATLAS matches the ticket to the right team based on category, location, and workload. Agents are notified instantly. SLA clocks start the moment a ticket is created.',
  },
  {
    num: '03',
    title: 'Collaborate & Resolve',
    desc: 'Agents work the ticket with full context — linked incidents, CMDB records, and a rich knowledge base at their fingertips. Status updates are pushed to the requester automatically.',
  },
  {
    num: '04',
    title: 'Close & Improve',
    desc: 'Once resolved, tickets are closed with root cause data captured. Problem Management uses this to prevent recurrence. Reports surface trends so leadership can act proactively.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" style={{ padding: '100px 0', background: 'rgba(255,255,255,0.01)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 32px' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <div style={{ display: 'inline-block', background: 'rgba(45,106,79,0.12)', border: '1px solid rgba(82,183,136,0.2)', borderRadius: '100px', padding: '5px 16px', fontSize: '12px', color: '#52b788', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '20px' }}>
            How It Works
          </div>
          <h2 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(32px,4vw,52px)', fontWeight: 800, letterSpacing: '-1.5px', marginBottom: '16px' }}>
            From request to resolution
          </h2>
          <p style={{ fontSize: '17px', color: '#a8b4cc', maxWidth: '500px', margin: '0 auto' }}>
            A structured, repeatable flow that scales from 10-person IT teams to enterprise operations.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0', position: 'relative' }} className="steps-grid">
          {/* Connector line */}
          <div style={{ position: 'absolute', top: '52px', left: 'calc(12.5% + 20px)', right: 'calc(12.5% + 20px)', height: '2px', background: 'linear-gradient(90deg, #2d6a4f, #52b788)', zIndex: 0 }} className="connector" />

          {steps.map((s, i) => (
            <div key={s.num} style={{ position: 'relative', zIndex: 1, padding: '0 20px', textAlign: 'center' }}>
              <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'linear-gradient(135deg, #2d6a4f, #40916c)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontFamily: "'Space Grotesk', sans-serif", fontWeight: 800, fontSize: '16px', color: '#fff', boxShadow: '0 0 0 6px #0a0f1e, 0 0 0 8px rgba(45,106,79,0.3)' }}>
                {s.num}
              </div>
              <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '18px', fontWeight: 700, color: '#fff', marginBottom: '12px' }}>{s.title}</h3>
              <p style={{ fontSize: '14px', color: '#a8b4cc', lineHeight: 1.65 }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <style>{`@media(max-width:800px){ .steps-grid{ grid-template-columns:1fr !important; } .connector{ display:none; } }`}</style>
    </section>
  );
}
